export const ActionsTypes = {
	ADD_RIGHTS: "ADD_RIGHTS",
	REMOVE_RIGHTS: "REMOVE_RIGHTS"
};
